import revive_payload_client_4sVQNw7RlN from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/builds/common/airbaltic-com/bt-frontend-nuxt/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_Jozdw60ZsE from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import titles_dw2T9lEw4h from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/@nuxtjs/seo/dist/runtime/nuxt/plugin/titles.js";
import defaultsWaitI18n_fcc0iSNKKy from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/@nuxtjs/seo/dist/runtime/nuxt/plugin/defaultsWaitI18n.js";
import siteConfig_izaWKZ8rEu from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt-seo-experiments/dist/runtime/nuxt/plugins/siteConfig.js";
import inferSeoMetaPlugin_Uk9bcXDHeN from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt-seo-experiments/dist/runtime/nuxt/plugins/inferSeoMetaPlugin.js";
import i18n_yfWm7jX06p from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_KlVwwuJRCL from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/@storyblok/nuxt/dist/runtime/plugin.mjs";
import plugin_t2GMTTFnMT from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import _01_locale_tQxnWxch4d from "/builds/common/airbaltic-com/bt-frontend-nuxt/plugins/01.locale.ts";
import _02_geolocation_client_pPuu9jlBJZ from "/builds/common/airbaltic-com/bt-frontend-nuxt/plugins/02.geolocation.client.ts";
import _03_sentry_client_RmhACl5F9Y from "/builds/common/airbaltic-com/bt-frontend-nuxt/plugins/03.sentry.client.ts";
import _04_cookie_bot_plugin_client_LXgvrdPkeb from "/builds/common/airbaltic-com/bt-frontend-nuxt/plugins/04.cookie-bot-plugin.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_Jozdw60ZsE,
  titles_dw2T9lEw4h,
  defaultsWaitI18n_fcc0iSNKKy,
  siteConfig_izaWKZ8rEu,
  inferSeoMetaPlugin_Uk9bcXDHeN,
  i18n_yfWm7jX06p,
  plugin_KlVwwuJRCL,
  plugin_t2GMTTFnMT,
  chunk_reload_client_UciE0i6zes,
  _01_locale_tQxnWxch4d,
  _02_geolocation_client_pPuu9jlBJZ,
  _03_sentry_client_RmhACl5F9Y,
  _04_cookie_bot_plugin_client_LXgvrdPkeb
]